import { createSlice } from "@reduxjs/toolkit";
import { pagination } from "../../../type/pagination";
import { listedDisease } from "../../../type/admins/listed-diseases"; 

export const listedDiseasesData = createSlice({
  name: "all listed diseases",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: pagination;
        data: listedDisease[];
      }[],
      data: [] as listedDisease[],
    },
  },
  reducers: {
    updateListedDiseases: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
    addDiseaseToList: (state, action) => {
      state.value.data = [...state.value.data, action.payload];
    },
    addToPaginationHistory: (state, action) => {
      const foundPage = state.value.pagination.find(
        (item) =>
          item?.pagination_data?.current_page ===
          action?.payload?.pagination_data?.current_page
      );
      if (foundPage) {
        //replace the found page with new data
        const foundPageIndex = state.value.pagination.findIndex(
          (item) =>
            item?.pagination_data?.current_page ===
            action?.payload?.pagination_data?.current_page
        );
        state.value.pagination[foundPageIndex] = action.payload;
      } else {
        //add new page to pagination history
        state.value.pagination = [...state.value.pagination, action.payload];
      }
    },
    removeDiseaseInList: (state, action) => {
      const foundDiseaseIndex = state.value.data.findIndex(
        (item) => item._id === action.payload
      );
      if (foundDiseaseIndex !== -1) {
        state.value.data.splice(foundDiseaseIndex, 1);
      }
    },
    replaceDiseaseInList: (state, action) => {
      const foundDiseaseIndex = state.value.data.findIndex(
        (item) => item._id === action.payload._id
      );
      if (foundDiseaseIndex !== -1) {
        state.value.data[foundDiseaseIndex] = action.payload;
      }
    },
    clearListedDiseaseList: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  updateListedDiseases,
  addDiseaseToList,
  addToPaginationHistory,
  removeDiseaseInList,
  replaceDiseaseInList,
  clearListedDiseaseList,
} = listedDiseasesData.actions;

export default listedDiseasesData.reducer;
